import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { TimeProps } from './time';
import { Time } from './time';

export interface HfTimeProps<TFieldValues extends FieldValues = FieldValues> extends TimeProps {
  control: Control<TFieldValues>;
  name: string;
}

export function HfTime<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  value,
  readOnly,
  required,
  disabled,
  onChange,
  fieldValueConverter,
  labelStyles,
  populateOnFocus,
}: HfTimeProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange: handleChange, value: fieldValue }, fieldState: { error } }) => (
        <Time
          name={name}
          label={label}
          value={fieldValue}
          error={error?.message}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          onChange={handleChange}
          labelStyles={labelStyles}
          populateOnFocus={populateOnFocus}
        />
      )}
    />
  );
}
